export default __webpack_public_path__ + "static/media/mapa.c89d897f.png";